const combineCollect = (...collects) => {
    return (type, location) => collects.reduce((result, collect) => {
        const data = type === 'event' ? collect('event') : collect('pageView', location);
        return { ...result, ...data };
    }, {});
};
export default combineCollect;
